import * as Yup from "yup";
export const loginSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email format")
    .required("Please enter email"),

  password: Yup.string()
    .required("Please enter password")
    .min(8, "Password must be at least 8 characters")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/\d/, "Password must contain at least one number")
    .matches(
      /[@$!%*?&#]/,
      "Password must contain at least one special character"
    ),
});

export const forgotPasswordSchema = Yup.object({
  password: Yup.string()
    .required("Please enter password")
    .min(8, "Password must be at least 8 characters")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/\d/, "Password must contain at least one number")
    .matches(
      /[@$!%*?&#]/,
      "Password must contain at least one special character"
    ),
});

export const emailSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email format")
    .required("Please enter email"),
});
export const otpVerificationSchema = Yup.object().shape({
  otp: Yup.string()
    .required("OTP is required")
    .length(6, "OTP must be 6 digits"),
});
export const userSchema = Yup.object({
  name: Yup.string()
    .trim()
    .required("Name is required")
    .min(2, "Name must be at least 2 characters")
    .max(50, "Name must be at most 50 characters"),
  // lastName: Yup.string()
  //   .trim()
  //   .required("Name is required")
  //   .min(2, "Name must be at least 2 characters")
  //   .max(50, "Name must be at most 50 characters"),

  cellNumber: Yup.string()
    .matches(/^\+923\d{9}$/, "Invalid phone number format")
    .required("Cell number is required"),

  image: Yup.string(),
  password: Yup.string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    // .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    // .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    // .matches(/\d/, "Password must contain at least one number")
    // .matches(
    //   /[@$!%*?&#]/,
    //   "Password must contain at least one special character"
    // ),
});

export const refundAndCancelSchema = Yup.object().shape({
  totalAmount: Yup.string(), // Modify as needed
  // refundAmount: Yup.number()
  //   .typeError("Refund amount must be a valid number")
  //   .required("Refund amount is required"),
  reason: Yup.string(), // Modify as needed
});

export const addBookingSchema = Yup.object().shape({
  totalAmount: Yup.string(), // Modify as needed
  refundAmount: Yup.number()
    .typeError("Refund amount must be a valid number")
    .required("Refund amount is required"),
  reason: Yup.string(), // Modify as needed
});

export const addCouponSchema = Yup.object().shape({
  couponCode: Yup.string().required("Coupon Code is required"),
});

// paymentReceived

export const paymentReceivedSchema = Yup.object().shape({
  paymentReceived: Yup.string()// Modify as needed
});
